import { render, staticRenderFns } from "./PassDialog.vue?vue&type=template&id=7b47aa4d&"
import script from "./PassDialog.vue?vue&type=script&lang=js&"
export * from "./PassDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports